<script>
  import { onMount } from "svelte";
  export let query = "";
  export let onSearch;
  export let isVisible;

  let value = query;

  function handleChange(event) {
    let q = event.target.value;
    value = q;
    if (value === "") {
      value = null;
    }
    onSearch(value);
  }

  onMount(function () {
    let el = document.getElementById("product-line-search__input");
    if (el) el.focus();
  });

</script>

<div class="search__search-input">
  <input
    class={`default-headline--regular ${isVisible ? "scale-search" : "descale-search"}`}
    placeholder="Search Products"
    type="text"
    id="product-line-search__input"
    {value}
    on:keyup={handleChange}
    autoCapitalize="off"
    autoCorrect="off"
    autoComplete="off"
  />
</div>
